module.exports = __webpack_public_path__ + "static/img/14000274.9924413a.png";